<template>
  <div class="select">
    <v-select
      :class="[selectColor, { error: isError }]"
      v-bind="$attrs"
      v-model="selected"
      autocomplete="nope"
      @input="input"
      append-to-body
      :calculate-position="withPopper"
    >
      <template #search="{ attributes, events }">
        <div :class="['input-with-icon', { 'with-icon': icon }]">
          <!-- Conditionally render the icon if the icon prop is provided -->
          <img
            v-if="icon"
            :src="icon"
            alt="input icon"
            class="input-icon"
          />
          <!-- Input Field -->
          <input
            class="vs__search"
            v-bind="attributes"
            v-on="events"
            @blur="blur"
          />
        </div>
      </template>
      <template #open-indicator>
        <span v-if="isError" class="chevron"></span>
        <img
          v-else
          class="vs__open-indicator"
          src="../../assets/icons/Tailing.svg"
          alt="arrow"
        />
      </template>
      <template #no-options>
        <p>{{ $t('general.noMatch') }}</p>
      </template>
    </v-select>
    <transition v-if="isError" name="error">
      <p class="error__message">
        {{ errorMessage }}
      </p>
    </transition>
  </div>
</template>

<script>
import { createPopper } from '@popperjs/core'

export default {
  props: {
    selectColor: {
      type: String,
      default: 'dark'
    },
    value: {
      type: [String, Number, Object, Array],
      default: () => ({})
    },
    required: {
      type: Boolean,
      default: false
    },
    dropdownStyle: {
      type: String,
      default: 'dark'
    },
    icon: {
      type: String, // The path to the icon
      default: null // No icon by default
    }
  },

  data() {
    return {
      selected: '',
      isError: false,
      placement: 'bottom'
    }
  },

  computed: {
    errorMessage() {
      return this.$t('errors.required')
    }
  },

  watch: {
    value(val) {
      if (val !== null && val !== undefined) {
        this.selected = val
        if (this.required) {
          this.isError = false
        }
      }
      if (val === null || val === undefined) {
        this.selected = ''
        if (this.required) {
          this.isError = true
        }
      }
    }
  },

  mounted() {
    if (this.value) {
      this.selected = this.valu
    }
  },

  methods: {
    input(e) {
      this.$emit('input', e)
    },
    blur() {
      if (this.required) {
        if (
          this.selected === null ||
          this.selected === undefined ||
          this.selected === ''
        ) {
          this.isError = true
          return
        }
        this.isError = false
      }
    },
    withPopper(dropdownList, component, {width}) {
      dropdownList.style.width = width
      dropdownList.classList.add(`dropdown-style__${this.dropdownStyle}`)

      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -10]
            }
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn({state}) {
              component.$el.classList.toggle(
                'drop-up',
                state.placement === 'top'
              )
            }
          }
        ]
      })

      return () => popper.destroy()
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/base/base_select.scss';

.select {
  position: relative;

  .input-with-icon {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;

    &.with-icon  {
      padding-left: 40px; /* Padding only when icon is present */
    }

    .input-icon {
      position: absolute;
      width: 20px; /* Adjust size as needed */
      height: 20px; /* Adjust size as needed */
      left: 10px;
    }

    .vs__search {
      flex: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseSelect.vue